export default defineNuxtPlugin(() => {
	return {
		provide: {
			installTebi,
			installSoigne,
			installMice,
		},
	};
});

const installTebi = (language) => {
	if (typeof window === 'undefined') {
		return;
	}

	const scriptId = 'tebi';
	const existingScript = document.getElementById(scriptId);
	if (existingScript) {
		existingScript.setAttribute('data-lang', language);
		const iframe = document.querySelector('[id="tebi_rs_01"] iframe');
		if (iframe) {
			iframe.loading = 'eager';
			const iframeUrl = new URL(iframe.src);
			if (iframeUrl.searchParams.get('lang') !== language) {
				iframeUrl.searchParams.set('lang', language);
				iframe.src = iframeUrl.toString();
			}
		}

		return;
	}

	const script = document.createElement('script');
	script.id = scriptId;
	script.src = 'https://live.tebi.co/ecom/widget-manager.js';
	script.setAttribute('data-widget-token', '114256_a0be07f0d29ed4187b2caf4d8a42770a8496c2b1fa1f98c7c34f6a44b615969b');
	script.setAttribute('data-no-minify', '1');
	script.setAttribute('data-lang', language);
	// Tebi starts outside the viewport, so lazy loading can prevent it from appearing.
	const loadIframe = () => document.querySelector('[id="tebi_rs_01"] iframe')?.setAttribute('loading', 'eager');
	script.addEventListener(
		'load',
		() => {
			loadIframe();
			if (document.readyState !== 'complete') {
				window.addEventListener('load', loadIframe, { once: true });
			}
		},
		{ once: true },
	);
	document.head.appendChild(script);
};

const installSoigne = () => {
	if (typeof window === 'undefined') {
		return;
	}

	const scriptId = 'soigne-client-script';
	if (document.getElementById(scriptId)) {
		return;
	}

	const script = document.createElement('script');
	script.id = scriptId;
	script.src = 'https://hiring-assistant.soigne.app/sdk.js';
	script.defer = true;
	script.setAttribute('data-assistant', '66f6a73b2d6cf74f0a5e1f79');

	document.head.appendChild(script);
};

const installMice = () => {
	if (typeof window === 'undefined') {
		return;
	}

	const scriptId = 'mice-client-script';
	if (document.getElementById(scriptId)) {
		return;
	}

	const script = document.createElement('script');
	script.id = scriptId;
	script.src = 'https://app.miceoperations.com/widget/widget.js';

	document.body.appendChild(script);
};
